module.exports = __webpack_public_path__ + "static/img/logo_mkcl.4997ce6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mkcl.svg
// module id = TIz9
// module chunks = 1